import { render, staticRenderFns } from "./ShortMessageNotice.vue?vue&type=template&id=8192dd72&scoped=true&"
import script from "./ShortMessageNotice.vue?vue&type=script&lang=js&"
export * from "./ShortMessageNotice.vue?vue&type=script&lang=js&"
import style0 from "./ShortMessageNotice.vue?vue&type=style&index=0&id=8192dd72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8192dd72",
  null
  
)

export default component.exports